import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getStoredConsent,
  loadAnalytics,
  setStoredConsent,
} from '../lib/analytics';
import { getLandingUrl } from '../lib/urls';

// Banner de consentimiento de cookies para la web app (app.suscri.net).
// Bloquea la analítica hasta que el usuario decide.
export function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getStoredConsent() === null) setVisible(true);
  }, []);

  const accept = () => {
    setStoredConsent('accepted');
    loadAnalytics();
    setVisible(false);
  };

  const reject = () => {
    setStoredConsent('rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label={t('Consentimiento de cookies')}
      className="fixed inset-x-0 bottom-0 z-50 border-t border-gray-200 bg-white/95 p-4 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] backdrop-blur-sm dark:border-gray-800 dark:bg-slate-950/95 sm:p-5"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 sm:flex-row sm:justify-between">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {t(
            'Usamos cookies necesarias para el funcionamiento y, si lo aceptas, cookies analíticas. Más info en la'
          )}{' '}
          <a
            href={`${getLandingUrl()}/cookies`}
            className="font-medium text-blue-600 underline dark:text-blue-400"
          >
            {t('política de cookies')}
          </a>
          .
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            onClick={reject}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
          >
            {t('Rechazar')}
          </button>
          <button
            onClick={accept}
            className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-blue-700"
          >
            {t('Aceptar')}
          </button>
        </div>
      </div>
    </div>
  );
}
